import { permissionMap } from "../config/permissionMap";

// Function to check if a role has access to a specific permission
export const hasAccess = (role, accessType) => {
  return permissionMap[role?.toLowerCase()]?.includes(accessType);
};
